// extracted by mini-css-extract-plugin
export default {"root":"card__root__MSCyk","content":"card__content__QFTzr","contentWide":"card__contentWide__EdfaW","title":"card__title__RLBUB","secondTitle":"card__secondTitle__tTxzj"};